import { formatCurrency } from '../../helper'
import { quoteLineType } from '../../types'
import { SupplierPartField } from '../SupplierPartDrawer'

export type SupplierCatalogColumn<T> = {
  label: string
  className: string
  align?: 'right'
  render: (row: T) => string
}

export type SupplierCatalogConfig<T> = {
  supplier: string
  endpoint: string
  rowKey: (row: T) => string | number
  partNumber: (row: T) => string
  columns: SupplierCatalogColumn<T>[]
  drawerFields: (row: T) => SupplierPartField[]
  toLineItem: (lineNumber: number, row: T) => Partial<quoteLineType>
}

export type SupplierCatalogPageData<T> = { rows: T[]; total: number }

export type WithRowId<T> = T & { rowId: number }

export const fieldRowsToFields =
  <T>(fieldRows: { name: string; accessor: (item: T) => string }[]) =>
  (item: T): SupplierPartField[] =>
    fieldRows.map(row => ({ label: row.name, value: row.accessor(item) }))

const dash = '—'
export const text = (v: string | number | null | undefined) =>
  v === null || v === undefined || v === '' ? dash : String(v)
export const currency = (v: number | null | undefined) => (v === null || v === undefined ? dash : formatCurrency(v))
export const emptyColumn = () => dash
